import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import TaxState from '../../types/TaxState'

const mutations: MutationTree<TaxState> = {
  [types.TAX_UPDATE_RULES] (state, taxClasses) {
    state.rules = taxClasses.items
  },
  [types.TAX_SET_CALCULATING] (state, skus: string[]) {
    state.calculatingTaxesForSkus = [...new Set([...state.calculatingTaxesForSkus, ...skus])]
  },
  [types.TAX_CLEAR_CALCULATING] (state, skus: string[]) {
    state.calculatingTaxesForSkus = state.calculatingTaxesForSkus.filter(sku => !skus.includes(sku))
  }
}

export default mutations
